import type { EnhancedProductFamilyId, EnhancedProductVariantId } from '#api/enhancements/enhancedTmsApiTypes'
import type { AdminNatCodesCode, AdminNatCodesFamily, AdminNatCodesGroup } from '#api/tmsApiService'
import type { MarketWithNationalCodes } from '#features/NationalCodes/loadNationalCodes'
import type { TruckConfiguration } from '#store/slices/configurationSlice'

export interface FamilySelectionMetaData {
  group: AdminNatCodesGroup
  family: AdminNatCodesFamily
  initialVariant?: AdminNatCodesCode
  previousVariant?: AdminNatCodesCode
  targetVariant?: AdminNatCodesCode
}

export function collectFamilySelectionMetaData(
  marketData: MarketWithNationalCodes | undefined,
  familyId: EnhancedProductFamilyId,
  previousVariantId?: EnhancedProductVariantId,
  targetVariantId?: EnhancedProductVariantId,
) {
  if (!marketData) {
    return undefined
  }

  for (const group of marketData.groups) {
    if (!group.families) {
      continue
    }

    for (const family of group.families) {
      if (!family.codes) {
        continue
      }

      if (family.familyId !== familyId) {
        continue
      }

      const result: FamilySelectionMetaData = {
        group,
        family: family,
      }

      if (family.codes) {
        for (const code of family.codes) {
          if (code.executionId === targetVariantId) {
            result.targetVariant = code
          }
          if (code.executionId === previousVariantId) {
            result.previousVariant = code
          }
          if (code.executionId === 'Z') {
            result.initialVariant = code
          }
        }

        if (!result.initialVariant) {
          result.initialVariant = family.codes[0]
        }
        if (!result.previousVariant) {
          result.previousVariant = result.initialVariant
        }
      }

      return result
    }
  }

  return undefined
}

export function getFamilySelectionMetaData(
  family: AdminNatCodesFamily,
  selection: TruckConfiguration['configuredFamilies'][EnhancedProductFamilyId],
) {
  if (!family.codes || family.codes.length === 0) {
    return undefined
  }

  if (selection?.selectedVariant) {
    return family.codes.find((code) => code.executionId === selection.selectedVariant)
  }

  return family.codes.find((code) => code.executionId === 'Z') || family.codes[0]
}
